import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { SerializerUtil } from './serializer.util';

export namespace UrlUtil {
  export const VARIATION_PREFIX = 'v_';
  export const FACET_PREFIX: string = 'facet_';
  export const SORT_PREFIX: string = 'sorting';
  export const REPLACE_PREFIX: string = 'replace';
  export const SEARCH_PREFIX: string = 'searchTerms';
  export const INTERVAL_PREFIX: string = 'priceRangeInterval';
  export const SIZE_PREFIX: string = 'size';
  export const TAGS_PREFIX: string = 'tags';
  export const FROM_PREFIX: string = 'from';
  export const STEP_PREFIX: string = 'step';
  const prefixList = [VARIATION_PREFIX, FACET_PREFIX, SORT_PREFIX, SEARCH_PREFIX, FROM_PREFIX, INTERVAL_PREFIX, STEP_PREFIX, SIZE_PREFIX];

  export function isReplacableKey(key: string) {
    return prefixList.includes(key) || key.startsWith(FACET_PREFIX)
  }

  export function safeUrl(search: URLSearchParams, url?: URL): URL {
    let currentUrl = url ?? new URL(window.location.href);
    Array
      .from(currentUrl.searchParams.keys())
      .forEach(key => prefixList.some(p =>
        key.startsWith(p)) ? currentUrl.searchParams.delete(key) : null
      );
    Array
      .from(search.entries())
      .filter(([key, value]) => value != null && value != '' && (Array.isArray(value) && value.length > 0))
      .forEach(([key, value]) => currentUrl.searchParams.append(key, value));


    return currentUrl;
  }

  export function replaceState(search: URLSearchParams, location: Location, router: Router, currentUrl: URL = new URL(window.location.href)) {
    let _url = UrlUtil.safeUrl(search, currentUrl);
    let url = SerializerUtil.serialize(_url);
    location.replaceState(url);
    router.getCurrentNavigation();
  }
}
